/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button } from '@chakra-ui/react';
import { type FunctionComponent } from 'react';
import { openInNewTabWithBearerToken } from '../../helper';
import { type Request } from '../../interface/Crash';

export const OpenResponseInTabButton: FunctionComponent<{
    kind: 'crash' | 'protocol';
    reportId: string;
    requestId: number;
}> = ({ kind, reportId, requestId }) => {
    const url = `/report/${kind}/responsebody/${reportId}/${requestId}`;

    return (
        <Button
            onClick={() => {
                openInNewTabWithBearerToken(url);
            }}
        >
            Open
        </Button>
    );
};
